import { makeNamespacedComponent } from '@/ui/utils';
import { GraphicsBanner as GraphicsBanner_, ImageArea, Title, Description } from './atoms';

export const GraphicsBanner = makeNamespacedComponent(GraphicsBanner_, { ImageArea, Title, Description });
